import { State } from 'src/app/shared/constants';

export enum AddressType {
    Legal = 'Legal',
    Billing = 'Billing',
    Shipping = 'Shipping',
    Service = 'Service',
    Return = 'Return',
    Site = 'Site',
}

export interface ICustomerAddressFilterOptions {
    includeTypes?: AddressType[];
    excludeTypes?: AddressType[];
}

export enum Country {
    AT = 'AT',
    DE = 'DE',
    CH = 'CH',
    ES = 'ES',
}

export interface IBaseCustomerAddress {
    type: AddressType;
    name: string; // 1..128
    addressLine?: string | null; // <=128
    addressLine2?: string | null; // <=128
    postCode: string; // 1..16
    city: string; // 1..128
    region?: State | null; // <=92
    country: Country;
    notes?: string | null;
    nameAffix1?: string | null; // <=128
    nameAffix2?: string | null; // <=128
}

export interface ICustomerAddress extends IBaseCustomerAddress {
    id: string; // uuid
    version?: string | null; // opaque version token
}
